import { render, staticRenderFns } from "./FeedbackHotline.vue?vue&type=template&id=742c9bf6&scoped=true&"
import script from "./FeedbackHotline.vue?vue&type=script&lang=js&"
export * from "./FeedbackHotline.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackHotline.vue?vue&type=style&index=0&id=742c9bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c9bf6",
  null
  
)

export default component.exports